export default {
  from: 'Datum von',
  to: 'Datum bis',
  price: 'Preis',
  weekName: 'Schlachtwoche',
  fillUp: 'Vorrausschreiben',
  fillUpTill: 'Vorrausschreiben bis',
  modal: {
    edit: "Schlachtwoche bearbeiten",
    add: "Schlachtwoche hinzufügen"
  },
  deleteModal: {
    title: 'Schlachtwoche wirklich löschen?',
    message: 'wirklich löschen?'
  },
  notification: {
    save: {
      type: 'success',
      message: 'Schweinepreis erfolgreich gespeichert',
      title: 'Erfolgreich gespeichert'
    },
    fillUp: {
      type: 'success',
      message: 'Schweinepreis erfolgreich voraus geschrieben',
      title: 'Erfolgreich geschrieben'
    }
  }
}
